import { returnNonNull } from 'src/common/helpers/ArraysHelper';
import {
	buildBoundingBox,
	buildElementInfo,
	MOBILE_SEVERITY_MAP
} from 'src/common/helpers/MobileQueriesHelper';
import { MobileIssueDetails, MobileWcagCriteria } from 'src/common/types/MobileSingleSessionTypes';

import { MobileSdkIssueDetailsQuery } from '../MobileSdkIssueDetails.generated';

const transformIssueToMobileIssueDetails = (
	issue: NonNullable<NonNullable<MobileSdkIssueDetailsQuery['issues']>[0]>
): MobileIssueDetails => {
	const elementInfo = buildElementInfo(issue);
	const boundingBox = buildBoundingBox(issue);

	// Parse WCAG criteria from tags if available
	const wcagCriteria: MobileWcagCriteria[] = [];
	issue.tags__description?.forEach((item, index) => {
		const title = item.trim();
		const link = issue.tags__link?.[index].trim();

		if (title && link) {
			wcagCriteria.push({ title, link });
		}
	});

	return {
		type: issue.type_name,
		description: issue.description,
		severity: MOBILE_SEVERITY_MAP[issue.severity_name],
		signature: issue.signature,
		screenshotDetails: {
			pageScreenshotUrl: issue.screenshot,
			boundingBox,
			viewportWidth: issue.viewport_width,
			viewportHeight: issue.viewport_height
		},
		taskManagerTickets: [],
		elementInfo,
		knowledgeBaseLink: issue.knowledge_base_link,
		expectations: [], // replace when schema will support issue expectations
		WCAGCriteria: wcagCriteria
	};
};

export const transformMobileSdkIssueDetailsResults = (
	result: MobileSdkIssueDetailsQuery
): MobileIssueDetails | null => {
	const issues = result.issues?.filter(returnNonNull);

	if (!issues?.length) {
		return null;
	}

	return transformIssueToMobileIssueDetails(issues[0]);
};
